import { isEmpty, omit } from 'lodash-es';

import { fetchDataByAsset } from './fetchDataByAsset';
import { aiDashboardAssets } from '../configs/constants';
import api from '../api';

const { getCancelToken } = api.buildRequestCancelation();

// Response transformers
const aiAppImpactTransformResponse = (data) => {
  if (isEmpty(data)) return { data: {} };

  return {
    data: {
      time_series: data || {},
    },
  };
};

// Request
export const fetchAiAppImpact =
  (nextFilters = {}) =>
  (dispatch, getState) => {
    const { aiDashboard } = getState();
    const { filters } = aiDashboard[aiDashboardAssets.aiAppImpact];

    const requestFilters = {
      ...filters,
      ...nextFilters,
    };

    dispatch(
      fetchDataByAsset(aiDashboardAssets.aiAppImpact, requestFilters, {
        cancelToken: getCancelToken('aiAppImpact').token,
        transformResponse: (data) => aiAppImpactTransformResponse(data),
        decorateRequestParams: (requestParams) => ({
          ...requestParams,
          params: {
            ...requestParams.params,
            filters: omit(requestFilters, ['app']),
          },
        }),
        decorateRequestAction: (action) => ({
          ...action,
          filters: requestFilters,
        }),
      })
    );
  };

// Response transformers
const financeAppsTransformResponse = (data, prevData, requestFilters) => {
  if (requestFilters.offset === 0) return { data };
  return {
    data: {
      ...data,
      finance_apps: [...prevData.finance_apps, ...data.finance_apps],
    },
  };
};

// Request
export const fetchFinanceApps =
  (nextFilters = {}, { enableFallbackPreselect } = {}) =>
  (dispatch, getState) => {
    const { aiDashboard } = getState();
    const { filters, data: prevData } = aiDashboard[aiDashboardAssets.financeApps];

    const requestFilters = {
      ...filters,
      ...nextFilters,
    };

    dispatch(
      fetchDataByAsset(aiDashboardAssets.financeApps, requestFilters, {
        cancelToken: getCancelToken('financeApps').token,
        transformResponse: (data) => financeAppsTransformResponse(data, prevData, requestFilters),
        decorateRequestAction: (action) => ({
          ...action,
          filters: requestFilters,
        }),
        onSuccess: (responseData) => {
          // Left this as a fallback in case the preselected app is missing in fetchFinanceAppPreselect
          if (enableFallbackPreselect) {
            const fallbackPreselectedApp = responseData.data.finance_apps[0];
            if (fallbackPreselectedApp) {
              dispatch(
                fetchAiAppImpact({
                  app_uid: fallbackPreselectedApp.unified_ref_no,
                  app: fallbackPreselectedApp,
                })
              );
            }
          }
        },
      })
    );
  };

const PRESELECTED_APP = {
  ref_no: '8080991038',
  name: 'Instagram',
};

export const fetchFinanceAppPreselect = () => (dispatch, getState) => {
  const { aiDashboard } = getState();
  const { filters, data: prevData } = aiDashboard[aiDashboardAssets.financeApps];

  const requestFilters = {
    ...filters,
    query: PRESELECTED_APP.name,
  };

  dispatch(
    fetchDataByAsset(aiDashboardAssets.financeApps, requestFilters, {
      transformResponse: (data) => financeAppsTransformResponse(data, prevData, requestFilters),
      onSuccess: (responseData) => {
        const preselectedApp = responseData.data.finance_apps?.find(
          (app) => app.ref_no === PRESELECTED_APP.ref_no
        );

        // Fetch the full list of apps to populate the dropdown
        dispatch(fetchFinanceApps({}, { enableFallbackPreselect: !preselectedApp }));

        if (preselectedApp) {
          dispatch(
            fetchAiAppImpact({ app_uid: preselectedApp.unified_ref_no, app: preselectedApp })
          );
        }
      },
    })
  );
};
